<template>
  <div>
<!-- 参数	说明	类型	可选值	默认值
  visible	是否显示 Dialog，支持 .sync 修饰符	boolean	—	false
  title	Dialog 的标题，也可通过具名 slot （见下表）传入	string	—	—
  width	Dialog 的宽度	string	—	50%
  fullscreen	是否为全屏 Dialog	boolean	—	false
  top	Dialog CSS 中的 margin-top 值	string	—	15vh
  modal	是否需要遮罩层	boolean	—	true
  modal-append-to-body	遮罩层是否插入至 body 元素上，若为 false，则遮罩层会插入至 Dialog 的父元素上	boolean	—	true
  append-to-body	Dialog 自身是否插入至 body 元素上。嵌套的 Dialog 必须指定该属性并赋值为 true	boolean	—	false
  lock-scroll	是否在 Dialog 出现时将 body 滚动锁定	boolean	—	true
  custom-class	Dialog 的自定义类名	string	—	—
  close-on-click-modal	是否可以通过点击 modal 关闭 Dialog	boolean	—	true
  close-on-press-escape	是否可以通过按下 ESC 关闭 Dialog	boolean	—	true
  show-close	是否显示关闭按钮	boolean	—	true
  before-close	关闭前的回调，会暂停 Dialog 的关闭	function(done)，done 用于关闭 Dialog	—	—
  center	是否对头部和底部采用居中布局	boolean	—	false
  ¶ Slot
  name	说明
  —	Dialog 的内容
  title	Dialog 标题区的内容
  footer	Dialog 按钮操作区的内容
  ¶ Events
  事件名称	说明	回调参数
  open	Dialog 打开的回调	—
  close	Dialog 关闭的回调	—
  closed	Dialog 关闭动画结束时的回调 -->
    <el-dialog
        class="dialog"
        :modal="true"
        :modal-append-to-body="true"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :title="title"
        :visible.sync="visible"
        :width="width"
        :height="height"
        :top="top"
        :show-close="true"
        :custom-class="customClass"
        @close="close">
        <slot></slot>
        <div slot="footer" class="dialog-footer" v-if="$slots.footer">
            <slot name="footer"></slot>
        </div>
  </el-dialog>
</div>
</template>
<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      default: true
    },
    switchStyle: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: '标题'
    },
    width: {
      type: String,
      default: '35%'
    },
    height: {
      type: String,
      default: '400px'
    },
    top: {
      type: String,
      default: '7vh'
    },
    isTab: {type: Boolean, default: false} // 是否是tab
  },
  data() {
    return {
      visible: this.isShow
    }
  },
  computed: {
    customClass: {
      get () {
        return this.isTab ? 'dialog-tab' : ''
      }
    }
  },
  methods: {
    close() {
      this.visible = false
      this.$emit('resetForm')
      this.$emit('update:isShow', false)
    }
  },
  watch: {
    isShow () {
      this.visible = this.isShow
    }
  }
}
</script>
<style lang="less">
  .dialog {
    .el-dialog { // dialog垂直居中
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 50%;
        left: 50%;
        max-width:calc(100% - 30px);
        min-height: 280px;
        max-height:calc(100% - 100px);
        margin: 0 !important;
        transform:translate(-50%, -50%);
        .el-dialog__body{
            flex:1;
            overflow: auto;
        }
        .el-dialog__footer {
            padding: 10px 20px;
            border-top: solid 1px #EEEEEE;
        }
    }
    .el-dialog__header {
        height: 40px;
        line-height: 40px;
        padding: 0 20px;
        background: #f3f3f3;
        .el-dialog__title{
            font-size: 14px;
            font-weight: 400;
            color: #333333;
        }
        .el-dialog__headerbtn {
            top: 12px;
        }
    }
    .el-dialog__body{
        padding: 20px;
    }
  }
</style>
